import React from 'react'
import PropTypes from 'prop-types'
import {Box, SimpleGrid, Text, useMultiStyleConfig} from '@chakra-ui/react'
import SanitizedHtml from '../../html-sanitizer'
import {isHydrated} from '@salesforce/retail-react-app/app/utils/utils'

const mapColor = {
    White: 'white',
    Grey: 'grey',
    Black: 'black',
}

const TextGroup = ({title, description, color, titleAs = 'div'}) => {
    const styles = useMultiStyleConfig('TextGroup', {
        variant: mapColor[color],
    })

    return (
        <Box {...styles.container}>
            <SimpleGrid {...styles.content}>
                {title && (
                    <Text as={titleAs} {...styles.title}>
                        {title}
                    </Text>
                )}
                {description && isHydrated() && (
                    <SanitizedHtml as={Text} html={description} {...styles.description} />
                )}
            </SimpleGrid>
        </Box>
    )
}

TextGroup.displayName = 'TextGroup'

TextGroup.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    color: PropTypes.oneOf(['Black', 'White', 'Grey']),
    titleAs: PropTypes.string,
}

export default TextGroup
